import React, { useEffect, useState } from 'react';
import './ServicesManager.css';

const API_URL = 'https://www.actrofiteinfotech.com/rootservices/dashboard/subServicesAPI.php';

export default function ServicesManager() {
  const [services, setServices] = useState([]);
  const [mainServices, setMainServices] = useState([]);
  const [filter, setFilter] = useState('');
  const [editingService, setEditingService] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [addFormData, setAddFormData] = useState({});
  const [editMessage, setEditMessage] = useState(null);
  const [addMessage, setAddMessage] = useState(null);

  const calculateDiscountPrice = (price, percent) => ((price * (100 - percent)) / 100).toFixed(2);

  // Fetch services
  const fetchServices = (filterVal = '') => {
    let url = API_URL + (filterVal ? `?main_service=${filterVal}` : '');
    fetch(url)
      .then(res => res.json())
      .then(data => {
        setServices(data);
        const distinct = [...new Set(data.map(item => item.main_service).filter(Boolean))];
        setMainServices(distinct);
      })
      .catch(console.error);
  };

  useEffect(() => { fetchServices(); }, []);

  const handleFilterChange = (e) => { 
    const val = e.target.value; 
    setFilter(val); 
    fetchServices(val); 
    setEditingService(null); 
    setEditMessage(null); 
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    const formData = new FormData();
    formData.append('id', id);
    try {
      const res = await fetch('https://www.actrofiteinfotech.com/rootservices/dashboard/deleteService.php', { method: 'POST', body: formData });
      const json = await res.json();
      alert(json.success ? json.message : (json.error || 'Delete failed'));
      fetchServices(filter);
    } catch { alert('Network error'); }
  };

  const startEditing = svc => {
    setEditingService(svc.id);
    setEditFormData({
      ...svc,
      image_file: null
    });
    setEditMessage(null);
  };

  const handleEditChange = e => {
    const { name, value, files } = e.target;
    setEditFormData(fd => ({
      ...fd,
      [name]: name === 'image_file' ? files[0] || null : value,
      discount_price: (name === 'price' || name === 'discount_percent') 
        ? calculateDiscountPrice(
            name === 'price' ? value : fd.price, 
            name === 'discount_percent' ? value : fd.discount_percent
          ) 
        : fd.discount_price
    }));
  };

  const handleEditSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(editFormData).forEach(([k, v]) => v !== null && v !== '' && formData.append(k, v));
    formData.append('action', 'update');
    try {
      const res = await fetch(API_URL, { method: 'POST', body: formData });
      const json = await res.json();
      if (res.ok && json.success) {
        setEditMessage({ type: 'success', text: json.message });
        fetchServices(filter);
        setTimeout(() => setEditingService(null), 1500);
      } else setEditMessage({ type: 'error', text: json.error || 'Update failed' });
    } catch { setEditMessage({ type: 'error', text: 'Network error' }); }
  };

  const handleAddChange = e => {
    const { name, value, files } = e.target;
    setAddFormData(fd => ({
      ...fd,
      [name]: name === 'image_file' ? files[0] || null : value,
      discount_price: (name === 'price' || name === 'discount_percent') 
        ? calculateDiscountPrice(
            name === 'price' ? value : fd.price, 
            name === 'discount_percent' ? value : fd.discount_percent
          ) 
        : fd.discount_price
    }));
  };

  const handleAddSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(addFormData).forEach(([k,v]) => v !== null && v !== '' && formData.append(k,v));
    formData.append('action','add');
    try {
      const res = await fetch(API_URL, { method:'POST', body:formData });
      const json = await res.json();
      if (res.ok && json.status==='success') {
        setAddMessage({type:'success', text: json.message});
        fetchServices(filter);
        setAddFormData({});
        document.getElementById('add-image-file').value='';
      } else setAddMessage({type:'error', text:json.message||'Insert failed'});
    } catch { setAddMessage({type:'error', text:'Network error'}); }
  };

  return (
    <div className="services-manager-wrapper">
      <h2>Services Manager</h2>

      {/* Filter */}
      <div className="filter-section">
        <label>Filter by Main Service:</label>
        <select value={filter} onChange={handleFilterChange}>
          <option value="">-- All --</option>
          {mainServices.map(ms => <option key={ms} value={ms}>{ms}</option>)}
        </select>
      </div>

      {/* Service Cards */}
      <div className="services-cards">
        {services.length===0 && <p className="no-services">No services found.</p>}
        {services.map(svc => (
          <div key={svc.id} className="service-card">
            <div className="service-image">
              {svc.image_url ? <img src={svc.image_url} alt={svc.sub_service_title} /> : <div className="no-image">No Image</div>}
            </div>
            <div className="service-info">
              <h3>{svc.sub_service_title}</h3>
              <p className="main-service">{svc.main_service}</p>
              <p className="desc">{svc.sub_service_description}</p>
              <p className="pricing">
                <span className="price">₹{svc.price}</span>
                {svc.discount_price && <span className="discount">₹{svc.discount_price}</span>}
                {svc.discount_percent && <span className="percent">({svc.discount_percent}%)</span>}
              </p>
              <div className="card-buttons">
                <button className="edit-btn" onClick={()=>startEditing(svc)}>Edit</button>
                <button className="delete-btn" onClick={()=>handleDelete(svc.id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Edit Modal */}
      {editingService && (
        <div className="edit-modal-overlay" onClick={()=>setEditingService(null)}>
          <div className="edit-modal-content" onClick={e=>e.stopPropagation()}>
            <h3>Edit Service ID: {editFormData.id}</h3>
            <form className="edit-form" onSubmit={handleEditSubmit} encType="multipart/form-data">
              <input type="text" name="main_service" placeholder="Main Service" value={editFormData.main_service || ''} onChange={handleEditChange} />
              <input type="text" name="sub_service_title" placeholder="Title" value={editFormData.sub_service_title || ''} onChange={handleEditChange} />
              <textarea name="sub_service_description" placeholder="Description" value={editFormData.sub_service_description || ''} onChange={handleEditChange} />
              <input type="number" name="price" value={editFormData.price || ''} onChange={handleEditChange} step="0.01" />
              <input type="number" name="discount_percent" value={editFormData.discount_percent || ''} onChange={handleEditChange} step="0.01" />
              <input type="number" name="discount_price" value={editFormData.discount_price || ''} readOnly />
              <input type="file" name="image_file" onChange={handleEditChange} />
              {editFormData.image_url && <img src={editFormData.image_url} alt="Preview" className="preview-image" />}
              <button type="submit" className="edit-submit-btn">Update</button>
              <button type="button" className="edit-cancel-btn" onClick={()=>setEditingService(null)}>Cancel</button>
              {editMessage && <p className={`edit-message ${editMessage.type}`}>{editMessage.text}</p>}
            </form>
          </div>
        </div>
      )}

      <hr className="separator" />

      {/* Add Service Form */}
      <h3>Add New Service</h3>
      <form className="add-service-form" onSubmit={handleAddSubmit} encType="multipart/form-data">
        <input type="text" name="main_service" value={addFormData.main_service||''} onChange={handleAddChange} placeholder="Main Service" required />
        <input type="text" name="sub_service_title" value={addFormData.sub_service_title||''} onChange={handleAddChange} placeholder="Title" required />
        <textarea name="sub_service_description" value={addFormData.sub_service_description||''} onChange={handleAddChange} placeholder="Description" required />
        <input type="number" name="price" value={addFormData.price||''} onChange={handleAddChange} step="0.01" required />
        <input type="number" name="discount_percent" value={addFormData.discount_percent||''} onChange={handleAddChange} step="0.01" />
        <input type="number" name="discount_price" value={addFormData.discount_price||''} readOnly />
        <input id="add-image-file" type="file" name="image_file" accept="image/*" onChange={handleAddChange} required />
        <button type="submit" className="add-submit-btn">Add Service</button>
        {addMessage && <p className={`add-message ${addMessage.type}`}>{addMessage.text}</p>}
      </form>
    </div>
  );
}
